import experimentFlags, { NAV_PAPER_BOUTIQUE } from 'util/experimentFlags';

class SecondaryNavWeddingShopData {
  constructor(userContext, weddingShopCategoryItems, isPostAuthNav3) {
    this.userContext = userContext;
    this.weddingShopCategoryItems = weddingShopCategoryItems;
    this.createSubCategory = this.createSubCategory.bind(this);
    this.isPostAuthNav3 = isPostAuthNav3;
    this.hasPaperTableNumberCardType = experimentFlags.isUnderTest(
      NAV_PAPER_BOUTIQUE,
      userContext,
      false
    );
  }

  getItems() {
    return this.weddingShopNavItemsNew();
  }

  createSubCategory(categories) {
    return categories.map((category) => {
      const giftsAndFavors = category.path === '/shop/category/wedding-gifts-favors';
      const intimates = category.path === '/shop/category/wedding-intimates';
      const partySupplies = category.path === '/shop/category/party-supplies-decor';
      const beautyAndWellness = category.path === '/shop/category/health-wellness';
      const identifier = category.path.substring(category.path.lastIndexOf('/') + 1);
      const children = category.children?.map((child) => {
        return {
          ...child,
          businessUnit: 'REGISTRY',
          children: child.children?.map((grandchild) => ({
            ...grandchild,
            businessUnit: 'REGISTRY',
          })),
        };
      });
      return {
        identifier,
        text:
          this.isPostAuthNav3 && category.title === 'Bridal Boutique' ? 'Bridal' : category.title,
        path: category.path,
        dropdownItems: children,
        showCaret: false,
        dockRight: intimates || beautyAndWellness,
        centerDropdown: partySupplies || giftsAndFavors,
        parent: 'Boutique',
        businessUnit: 'REGISTRY',
      };
    });
  }

  weddingShopNavItemsNew() {
    const weddingShopNav = [
      {
        identifier: 'new-arrivals',
        text: this.isPostAuthNav3 ? 'New' : 'New Arrivals',
        path: '/shop/collection/wedding-shop-new-arrivals',
        parent: 'Boutique',
        businessUnit: 'REGISTRY',
      },
    ];
    if (this.weddingShopCategoryItems?.categories) {
      return [
        ...weddingShopNav,
        ...this.createSubCategory(this.weddingShopCategoryItems.categories),
        ...(this.hasPaperTableNumberCardType
          ? [
              {
                id: 'invites-and-paper',
                title: 'Invites & Paper',
                path: this.userContext.is_guest
                  ? '/wedding-planning/paper'
                  : '/wedding-planning/universal',
                parent: 'Wedding Boutique',
                businessUnit: 'PAPER',
              },
            ]
          : []),
      ];
    }
    return [];
  }
}

export default SecondaryNavWeddingShopData;
